import { render, staticRenderFns } from "./FieldType2Configure.vue?vue&type=template&id=262cc4e6&scoped=true"
import script from "./FieldType2Configure.vue?vue&type=script&lang=js"
export * from "./FieldType2Configure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "262cc4e6",
  null
  
)

export default component.exports